import { useContext } from "react";
import { AcquisitionStoreContext } from "./ModernAcquisitionProvider";
import { IAcquisitionStore } from "./types";

export function useAcquisitionStore(): IAcquisitionStore {
    const store = useContext<IAcquisitionStore>(AcquisitionStoreContext);
    if (!store) {
        throw new Error('useAcqusitionStore must be used within NewAcquisitionProvider');
    }
    return store;
}

